var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMinus = props => /*#__PURE__*/React.createElement("svg", _extends({
  className: "svg-safari-fix",
  viewBox: "0 0 24 24",
  fill: "inherit",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5 13.0297C4.45 13.0297 4 12.5897 4 12.0297C4 11.4797 4.44 11.0297 5 11.0297L19 10.9697C19.55 10.9697 20 11.4097 20 11.9697C20 12.5197 19.56 12.9697 19 12.9697L5 13.0297Z",
  fill: "inherit"
})));
export default SvgMinus;